/*
    This file contains all the URLS belong to User Management menu
*/

export const GENERAL_URLS = {
  APP_LANDING_SCREEN: "/platform-selection", // Platform Selection
};
